function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "clock--gray");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.5
}, React.createElement("g", {
  id: "Artboard",
  transform: "translate(-44.000000, -18.000000)",
  fill: "#06273A"
}, React.createElement("path", {
  d: "M52,18 C56.418278,18 60,21.581722 60,26 C60,30.418278 56.418278,34 52,34 C47.581722,34 44,30.418278 44,26 C44,21.581722 47.581722,18 52,18 Z M52,19.8823529 C48.6213168,19.8823529 45.8823529,22.6213168 45.8823529,26 C45.8823529,29.3786832 48.6213168,32.1176471 52,32.1176471 C55.3786832,32.1176471 58.1176471,29.3786832 58.1176471,26 C58.1176471,22.6213168 55.3786832,19.8823529 52,19.8823529 Z M52,20.9411765 C52.479813,20.9411765 52.8757666,21.3002213 52.9338434,21.7642938 L52.9411765,21.8823529 L52.9411765,26.0070588 L54.7738481,26.9228921 C55.2000256,27.1359808 55.3938878,27.6287803 55.2441848,28.0675413 L55.194755,28.1856128 C54.9622945,28.6505337 54.3969552,28.8389802 53.9320343,28.6065197 L51.5790931,27.4300491 L51.5766227,27.4288095 C51.4683964,27.374497 51.3718368,27.299339 51.2923754,27.2088027 C51.2762469,27.1907484 51.2611746,27.1721381 51.2468685,27.1530305 C51.2383203,27.1413942 51.2300192,27.1298014 51.221979,27.1180165 C51.210552,27.1013609 51.1994875,27.0838815 51.1890222,27.0660822 C51.1771506,27.0460263 51.1662714,27.0259499 51.1561171,27.0054505 C51.1530532,26.9988961 51.1496917,26.991877 51.1464181,26.9848193 C51.1187323,26.9257034 51.0973032,26.8636365 51.0825215,26.7990359 C51.0772552,26.7752877 51.0728277,26.7520462 51.0692764,26.7286422 C51.0681643,26.7215738 51.0671145,26.7139484 51.0661566,26.7062945 L51.0638323,26.6863358 C51.0611165,26.6606525 51.0594521,26.6348126 51.0588235,26.608882 L51.0588235,26.5882353 L51.0588235,21.8823529 C51.0588235,21.3625555 51.4802026,20.9411765 52,20.9411765 Z",
  id: "clock--gray"
})));

var SvgClockGray = function SvgClockGray(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClockGray, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock--gray.f2bc4dea.svg";
export { ForwardRef as ReactComponent };